import httpService from "@/helper/httpService";

/**
 * Mixin to handle plz and ort.
 * The mixin
 * - provides a handler method for plz input
 * - sets "ort" directly if given plz results in  a single city
 * - provides a "cityList" field containing the currently available cities for the plz otherwise
 *
 * If "ort" is not a field in the component, you can use the optional parameter "ortBox". The handler method will
 * call "ortBox.ort" to set the value of ort if it is provided.
 *
 */
export default {
  data() {
    return {
      cityList: []
    };
  },
  methods: {
    onInputPlz(newPlz, ortBox) {
      if (/^[0-9]{5} ?$/.test(newPlz)) {
        const vm = this;
        httpService.getCitiesFromPlz(newPlz)
          .then(cities => {
            const ortSource = ortBox ? ortBox : vm;
            if (cities.length === 1) {
              vm.cityList = [];
              ortSource.ort = cities[0];
            } else {
              if(!(ortSource.ort && cities.includes(ortSource.ort))){
                ortSource.ort = "";
                const field = vm.$validator.fields.find({ name: 'ort' });
                const errBag = vm.$validator.errors;
                
                //template to overwrite a validation message just once
                //first force validation
                //then remove all other errors for the field
                //finally  add a custom errormessage
                vm.$validator.validate('ort').then(() => {
                  vm.$nextTick(() => {
                    errBag.removeById(field.id);
                    errBag.add({
                      field: 'ort',
                      msg: (cities.length === 0) ? `kein Ort mit Postleitzahl ${newPlz} gefunden` : `bitte einen der Orte mit Postleitzahl ${newPlz} auswählen` ,
                      id: field.id
                    });
                  });
                })
                .catch(e => console.log(e));
              } 
              vm.cityList = cities ?  cities.sort() : cities;
            }
          })
          // do nothing if call fails for any reason
          .catch();
      }
    }
  }
};
